var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubwallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 576,
    viewBox: "0 0 384 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_8069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384 208.319V128.389L63.9437 0L0 32.4718L0.337606 281.256L239.789 377.672L111.902 432.125V390.016L53.1885 366.182L0.337594 391.16L0.337613 543.528L64 576L384 431.625V329.214L96 213.939V144L324.5 235.296L384 208.319Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_8069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 576,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubwallet);
export default __webpack_public_path__ + "static/media/subwallet.c06a9fea998af2036bf8a081f1beeda6.svg";
export { ForwardRef as ReactComponent };